import langMap from '../constants/lang-map';
const getSortedLangsUtil=(lang)=>{
    return Object.entries(langMap)
    .filter(([k,v])=>k!=='auto')
    .sort((a,b)=>a[1].name[lang].localeCompare(b[1].name[lang]))
    .map(([k,v])=>k);
};
export default getSortedLangsUtil;

